import { useEffect, useRef } from 'react';

// The bottom layer: window bubble runs after every useLayerEscape layer and focused field, so it
// only fires for an Escape none of them stopped or prevented.
export function useModalEscape(onEscape: () => void): void {
    const handlerRef = useRef(onEscape);

    useEffect(() => {
        handlerRef.current = onEscape;
    }, [onEscape]);

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key !== 'Escape' || event.defaultPrevented) return;
            event.preventDefault();
            handlerRef.current();
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);
}
